import {
  SHOW_CLONE_SETTINGS_MODAL,
  SHOW_CLONE_SETTINGS_MODAL_HIDE
} from 'Redux/actionTypes';

export const showCloneSettingsModal = () => ({
  type: SHOW_CLONE_SETTINGS_MODAL,
  payload: {  }
});

export const showCloneSettingsHide = () => ({
  type: SHOW_CLONE_SETTINGS_MODAL_HIDE,
  payload: {}
});